import * as React from "react";
import { Typography, Card, CardContent, Grid } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import CodeIcon from "@mui/icons-material/Code";
import prismatic, { AuthenticateProps } from "@prismatic-io/embedded";
import { useEffect } from "react";
import { usePrismatic } from "./PrismaticContext";
import { EmbedConfig } from "./Integrate";

export const Connectors: React.VFC = (config:EmbedConfig) => {
  useEffect(() => {
    const { embedUrl: url, embedToken: token } = config;
  
    try {
      prismatic.init({ prismaticUrl: url });

      (async () => {
        const options: AuthenticateProps = {
          prismaticUrl: url,
          token: token,
        };

        await prismatic.authenticate(options);

        prismatic.showComponents({
            selector: `#marketplace-placeholder`,
            usePopover: false,
            theme: 'DARK',
          });
      })();
    } catch (error) {
      console.error("Failed to authenticate with Prismatic:", error);
    }
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <div id="marketplace-placeholder" style={{ height: "100vh" }}>
          Loading...
        </div>
      </Grid>
    </Grid>
  );
};
